  <!--Hamburger for Main Menu-->
<div class="mainMenu">
  <app-menu [childMessage]="loggedInUser?.userFirstName"></app-menu>
</div>

<!--Logo-->
<div class="logo">
  <a [routerLink]="['/']">
    <img src="../../../assets/images/kawneer_logo.JPG" alt="Kawneer logo">
  </a>
</div>
<!--end Logo-->
<!--Search Content-->
<div class="app-search-in-header-container">
  <div class="app-search">
    <div>
      <app-search></app-search>
    </div>
  </div>
  <!--end search-->
</div>
<!--end app-search-in-header-container-->
<!--end Search Content-->
<!--Account-->
<div class="account-container">
  <div class="account-menu-container">
    <div class="row">
      <div class="greeting-container">
        <div class="greeting">
          <app-sign-in>
          </app-sign-in>
        </div>

        <div class="signOut" #signOut>
          <button kendoButton [routerLink]="['/home']">
            <!--*ngIf="signOutText" (click)="signedOut()"-->
            <!--{{signOutLanguageLabel}}-->
          </button>
        </div>
        <!--end signOut button-->
      </div>
      <!--end greeting-->

    </div>
    <!--end row-->
    <!--Account List Items-->
    <ul class="account-list-items">

      <li class="fade-on-hover" #language (click)="onToggleLanguage()">
        <span class="k-icon k-i-globe-outline"></span><span class="k-icon k-i-arrow-60-down"></span>

        <!--Language Pop up-->
        <kendo-popup [anchor]="language" class="language-container" id="language-dropdown"
                     (click)="onToggleLanguage()">
          <div class="language-content">
            <ul>
              <li *ngFor="let language of languages" (click)="setLanguage(language.id)">
                <a>
                  <img [src]="language.image">&nbsp;{{language.value}}
                </a>
              </li>
            </ul>
          </div>
          <!--end language-content-->
        </kendo-popup>
        <!--END Language Pop Up-->

      </li>
      <li class="login fade-on-hover" #signIn (click)="onToggleSignIn()">
        <button class="sign-in-button" kendoButton primary="true" *ngIf="signInText">
          {{signInLanguageLabel}}
        </button>
      </li>

      <li class="profile fade-on-hover" #profile (click)="onToggleProfile();">
        <span *ngIf="showProfileIcon" class="k-icon k-i-user"></span>
      </li>
      <li [routerLink]="['cart']" (click)="gotoCart('/cart')" class="shopping-cart fade-on-hover">
        <span class="k-icon k-i-cart k-i-shopping-cart"></span>
        <span class="countOfCartItems" *ngIf="(totalCartItem$ | async)>0">
          {{totalCartItem$ | async}}
        </span>
      </li>

    </ul>
    <!--end Account List Items-->
  </div>
  <!--end menu-container-->
</div>
<!--end account-container-->
<!--POP UPS and DIALOGS-->
<!--Sign In Pop Up FORM-->
<kendo-popup id="sign-in-dropdown" [anchor]="signIn" (anchorViewportLeave)="showSignIn = false" *ngIf="showSignIn"
             class="sign-in-container">
  <div class="signIn-content col-xs-12 col-sm-12">
    <form class="k-form">
      <label class="k-form-field">
        <span>
          {{userIdLanguageLabel}}<span class="k-required requiredField">*</span>
        </span>
        <!--<input #useridInput (keyup)="onKey(useridInput.value)" class="k-textbox" />-->
        <input #useridInput [(ngModel)]="userId" name="userId" class="k-textbox"
               (keyup.enter)="focusableSubmit.click()" />
      </label>

      <label class="k-form-field">
        <span>
          {{passWordLanguageLabel}}<span class="k-required requiredField">*</span>
        </span>
        <input class="k-textbox" [(ngModel)]="userPassword" id="userPassword" name="userPassword" type="password"
               (keyup.enter)="focusableSubmit.click()" />
      </label>

      <button kendoButton primary="true" type="button" id="signInButton"
              class="mt-3 mb-3 k-button col-sm-12 sign-in-button" (click)="signedIn()" #focusableSubmit>
        {{signInLanguageLabel}}
      </button>
      <label>
        {{invalidUserCredential}}
      </label>
      <div *ngIf="showLoginAttempt">
        <label>
          {{loginAttemptMessage}}
        </label>
      </div>

      <p class="text-right">
        <a *ngIf="!openedForgotPassword" (click)="openForgotPasswordDialog()">{{forgotPassWordLanguageLabel}}?</a>
      </p>

      <p class="text-right">
        <a [routerLink]="['/new-user']" (click)="newUser()" class="">{{newUserLanguageLabel}}?</a>
      </p>
    </form>
  </div>
  <!--end Sign In Pop up FORM-->
</kendo-popup>


<!--KENDO POP UP MESSAGE FOR LOGIN/LOGOUT SUCCESS-->
<!--Change Customer popup --Start-->
<kendo-dialog title="Change Customer" *ngIf="changeCustomerDialog" (close)="closeChangeCustomerDialog()">
  <div class=" col-xs-12 col-sm-12">
    <form class="k-form" [formGroup]="changeCustomerForm">
      <div>
        <span>You are logged in as Customer: <b>{{loggedInUser.customerName}}</b></span>
        <br /><br />
        <!--formControlName="customerName"-->
        <kendo-autocomplete class="col" #customerName name="customerName"
                            [data]="filteredCustomerItems "
                            formControlName="customerName"
                            [valueField]="'fullCustomer'"
                            placeholder="Please type a Customer Name"
                            [virtual]="true"
                            [filterable]="true"
                            [highlightFirst]="false"
                            (filterChange)="handleCustomerFilter($event)"
                            (valueChange)="customerChangeSelected($event)"
                            [loading]="customerSearchLoading | async">
          <ng-template kendoAutoCompleteItemTemplate let-dataItem>

            <ng-container *ngFor="let substring of splitText(dataItem.fullCustomer)">
              <ng-container *ngIf="substring.toLowerCase() === currentInputValueInItemSearch.toLowerCase();
            else boldTemplateName
          ">
                <span>{{ substring }}</span>
              </ng-container>
              <ng-template #boldTemplateName>
                <b>{{ substring }}</b>
              </ng-template>
            </ng-container>
          </ng-template>

          <ng-template kendoAutoCompleteNoDataTemplate>
            <div *ngIf="showSuggestionBox">
              <h4>
                <span class="k-icon k-i-warning"></span>
                <br /><br />
                No items match
                <br />
                "{{ currentInputValueInItemSearch }}"
              </h4>
            </div>
          </ng-template>
        </kendo-autocomplete>
      </div>
      <div style="text-align:right">
        <button kendoButton class="m-3 customerBtnCls dialogBtnSize" (click)="closeChangeCustomerDialog()">
          Close
        </button>
        &nbsp;
        <button kendoButton class="m-3 btn btn-success customerBtnCls dialogBtnSize"
                (click)="changeCustomerSubmit()">
          Save
        </button>
      </div>

    </form>
  </div>
</kendo-dialog>
<!--Change Customer Pop up form end-->
<div id="loginSuccess" *ngIf="userLoggedInSuccess">
  <p>Login Successful!!!</p>
</div>

<div id="logoutSuccess" *ngIf="userLoggedOutSuccess">
  <p>You are Logged out</p>
</div>

<div id="loginFail" *ngIf="userLoggedInFail">
  <p>Invalid Username or password</p>
</div>

<!--END KENDO POP UP MESSAGE FOR LOGIN SUCCESS-->
<!--End Sign In Pop Up-->
<!--FORGOT PASSWORD DIALOG-->
<div class="form-control-lg">
  <kendo-dialog *ngIf="openedForgotPassword" (close)="close('cancel')" [minWidth]="250" [width]="450">

    <form class="k-form" [formGroup]="forgotPasswordForm" (ngSubmit)="closeForgotPasswordDialog()">

      <!--end confirmation-message-->
      <label class="k-form-field">
        <span style="margin: 30px; text-align: center; font-size:20px;">
          {{forgotPasswordEmailConfirmationLanguageLabel}}
        </span>
        <!--<input #useridInput (keyup)="onKey(useridInput.value)" class="k-textbox" />-->
        <input kendoTextBox formControlName="email"
               [ngClass]="{ 'ng-invalid ng-touched': submitted && f.email.errors }" />
      </label>

      <div class="text-center">

        <button kendoButton primary=true class="k-button mr-2" (click)="closeForgotPasswordDialog()">
          {{continueButtonLanguageLabel}}
        </button>
        <button kendoButton class="k-button" (click)="forgotPasswordCancel()">
          {{resetButtonLanguageLabel}}
        </button>
      </div>
      <!--end text-center-->
    </form>
  </kendo-dialog>
</div>
<!--END FORGOT PASSWORD DIALOG-->
<!--FORGOT PASSWORD CONFIRMATION DIALOG-->
<div class="forgotPasswordConfirmation-wrapper">
  <kendo-dialog *ngIf="openedForgotPasswordConfirmation" (close)="close('cancel')" [minWidth]="250" [width]="450">
    <p style="margin: 30px; text-align: center; font-size:20px;">
      <strong>Thank you,&nbsp;</strong>
      <br />
      your new password has been sent the email associated
      with your
      kawneerDirect account.
    </p>
    <kendo-dialog-actions>
      <button kendoButton class="" (click)="closeForgotPasswordConfirmation()">
        Ok
      </button>
      <!--<button kendoButton (click)="close('yes')" primary="true">Yes</button>-->
    </kendo-dialog-actions>
  </kendo-dialog>
</div>
<!--END FORGOT PASSWORD CONFIRMATION DIALOG-->
<!--END SIGN IN POPUP-->
<!--MANAGE PROFILE DROPDOWN-->
<kendo-popup id="profile-menu" [anchor]="profile" [animate]="animate" (anchorViewportLeave)="showProfile"
             class="profile-container" *ngIf="showProfile">
  <div class='profile-content'>
    <!-- User-defined profile-content -->
    <div class="profile-menu-header">
      <span class="k-icon k-i-user"></span><span class="logged-in-as">You are logged in as</span>
      <span class="usernameDisplay"><strong><em>&nbsp;{{userId}}</em></strong></span>
    </div>
    <div class="loggedUserCls">
      <!--<span class="center-class">Account Details for {{loggedInUser?.customerNumber}}</span><br />-->
      <span>Account Details for:{{ loggedInUser?.customerNumber}}</span><br />
      <span>Name:{{ loggedInUser?.customerName}}</span> <br />
      <!--<span>Account:123456</span> <br />--><!--Need to bind dynamic-->
      <!--<span>
        Billing Address:  {{loggedInUser?.addressLine1}}{{loggedInUser?.addressLine2}}<br />
        {{loggedInUser?.city}},{{loggedInUser?.state}} {{loggedInUser?.zipCode}}
      </span>-->
    </div>
    <!--end profile-menu-header-->
    <ul class="profile-menu-list-items">
      <li kendoButton *ngIf="!openedProfile" (click)="openProfileDialog()">
        <span class="k-icon k-i-lock"></span>
        <a style="cursor:pointer">
          Change Password
        </a>
      </li>
      <li (click)="openChangeCustomerDialog();" *ngIf="isSystemUserAdmin===true?isSystemUserAdmin:(loggedInUser?.isCSCAccount===true || loggedInUser?.isMSCAccount===true)">
        <span class="k-icon k-i-user"></span>
        <a>
          Change Customer
        </a>


      </li>
      <li>
        <span class="k-icon k-i-file-vertical"></span>
        <a [routerLink]="['customer-multiplier-plan']" (click)="closeProfile()">
          View/Print CMP
        </a>
      </li>
      <li *ngIf="isSystemUserAdmin===true?isSystemUserAdmin:loggedInUser.hasAccountSummary">
        <span class="k-icon k-i-dollar"></span> <a [routerLink]="['account-summary']" (click)="closeProfile()">
          Account Summary
        </a>
      </li>
      <li *ngIf="isSystemUserAdmin===true?isSystemUserAdmin:loggedInUser.hasManageAddress">
        <span class="k-icon k-i-marker-pin"></span>
        <a [routerLink]="['manage-address']" (click)="closeProfile()">
          Manage Address
        </a>
      </li>

      <li class="manageCompany" *ngIf="isManageCompanyAccess">
        <div class="manage-company-panelbar-wrapper">
          <kendo-panelbar class="manageCompany">
            <kendo-panelbar-item [icon]='"k-icon k-i-myspace"' [title]="'Manage Company'">
              <ng-template kendoPanelBarContent>
                <div class="manageCompanyLinks">
                  <div class="link">
                    <span class="listItem">
                      <span class="k-icon k-i-user"></span> <a [routerLink]="['manage-account']" (click)="closeProfile()">
                        Manage Accounts
                      </a>
                    </span>
                    <!--<span class="listItem">
                      <span class="k-icon k-i-user"></span>Manage
                      Accounts
                    </span>-->
                  </div>
                </div>
              </ng-template>
            </kendo-panelbar-item>
          </kendo-panelbar>
        </div>
        <!--end panelbar-wrapper-->
      </li>

    </ul>
  </div>

  <!--end profile-content-->
</kendo-popup>
<!--END MANAGE PROFILE DROPDOWN-->
<!--MANAGE PROFILE DROPDOWN - CHANGE PASSWORD DIALOG-->
<kendo-dialog title="Change Password" *ngIf="openedProfile" (close)="closeProfileDialog()" [minWidth]="250"
              [width]="450">
  <form novalidate (ngSubmit)="onSubmit()" [formGroup]="passwordForm">
    <div class="form-row">

      <div class="form-group col-md-12">
        <label class="lblCls">{{attributeEditDialog.newPasswordLbl}} <span class="requiredField">*</span></label>
        <div class="form-inline">
          <input type="password" kendoTextBox class="form-control pwdtextbox" name="newpassword"
                 (blur)="validateAttributeForm()"
                 [ngClass]="{'borderRed':attributeEditDialog.isInvalidNewPassword }"
                 formControlName="newpassword" />
          <span title="{{attributeEditDialog.passwordFormatMatch}}" *ngIf="attributeEditDialog.isPasswordFormatInValid " kendoTooltip
                class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
        </div>
      </div>
      <div class="form-group col-md-12">
        <label class="lblCls">
          {{attributeEditDialog.confirmPasswordLbl}}<span class="requiredField">*</span>
        </label>
        <input type="password" kendoTextBox class="form-control pwdtextbox" name="confirmpassword"
               [ngClass]="{'borderRed':attributeEditDialog.isInvalidConfirmPassword && attributeEditDialog.isSubmitted}"
               (blur)="validateAttributeForm()" formControlName="confirmpassword" />
        <span title="{{attributeEditDialog.confirmPasswordMatch}}" *ngIf="attributeEditDialog.isPasswordNotMatched && attributeEditDialog.isSubmitted" kendoTooltip
              class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
      </div>
    </div>

    <div class="form-group">
      <!--<label for="oldpasswordId" class="col-sm-6 col-form-label">
        Old Password
      </label>
      <div class="col-xs-6">
        <input id="oldpasswordId" class="form-control" type="password" maxlength="30" formControlName="oldPassword">
      </div>-->
      <!--<div formGroupName="passwordGroup" class="form-group">
        <div class="form-group col-md-12">
          <label for="newpasswordId" class="lblCls">
            New Password
          </label>
          <div class="col-xs-6">
            <input id="newpasswordId" class="form-control" type="password" maxlength="30" formControlName="newpassword"
                   [ngClass]="{'is-invalid': passwordForm.get('passwordGroup').errors ||
                       ((passwordForm.get('passwordGroup.newpassword').touched ||
                       passwordForm.get('passwordGroup.newpassword').dirty) &&
                       !passwordForm.get('passwordGroup.newpassword').valid) }" />
            <div class="invalid-feedback">
              <div *ngIf="passwordForm.get('passwordGroup.newpassword').errors?.minlength">
                <span class="k-icon k-i-warning k-i-exception k-i-error"></span>
                Password must be at least 8 characters
              </div>
            </div>
          </div>
        </div>
        <div class="form-group col-md-12">
          <label for="confirmpasswordId" class="lblCls">
            Confirm New
            Password
          </label>
          <div class="col-xs-6">
            <input id="comfirmpasswordId" class="form-control" type="password" maxlength="30"
                   formControlName="confirmpassword" [ngClass]="{'is-invalid': passwordForm.get('passwordGroup').errors ||
                       ((passwordForm.get('passwordGroup.confirmpassword').touched ||
                       passwordForm.get('passwordGroup.confirmpassword').dirty) &&
                       !passwordForm.get('passwordGroup.confirmpassword').valid) }" />
            <div class="invalid-feedback">
              <div *ngIf="passwordForm.get('passwordGroup').errors?.match">
                <span class="k-icon k-i-warning k-i-exception k-i-error"></span>
                Passwords do not match
              </div>
            </div>
          </div>
        </div>
      </div>-->
    </div>
    <!--end row-->
    <!--<div class="container">
      <div class="text-center mt-5">
        <button kendoButton primary="true" *ngIf="!openedPassword" (click)="savePassword()" class=""
                [title]="passwordForm.valid ? 'Save your entered data' : 'Disabled until the form data is valid'"
                [disabled]="!passwordForm.valid" [icon]="'floppy'">
          Save
        </button>
      </div>
    </div>-->

    <div class="dialog-btn-section">
      <div class="row">
        <div class="col-sm-12 float-left">
          <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 btn-align-center">
          <div class="btn-group" role="group">
            <button (click)="closeProfileDialog()" class=" m-3 btn k-button dialogBtnSize" kendoButton>
              Close
            </button> &nbsp;&nbsp;
            <button (click)="savePassword()" class="m-3 btn btn-success dialogBtnSize" kendoButton
                    [disabled]="saveInProcess">
              Save<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</kendo-dialog>
<!--END MANAGE PROFILE DROPDOWN - CHANGE PASSWORD DIALOG-->
<section class="dialogSection">
  <kendo-dialog title="Change Default Password" *ngIf="defaultPassword.opened" (close)="closeDefaultPasswordDialog()" [minWidth]="250"
                [width]="450">
    <form novalidate [formGroup]="defaultPasswordForm">
      <div class="form-row">
        <div class="form-group col-md-12">
          <label class="lblCls">{{defaultPassword.newPasswordLbl}} <span class="requiredField">*</span></label>
          <div class="form-inline">
            <input type="password" kendoTextBox class="kendoInput" name="newPassword"
                   (blur)="validateDefaultPasswordForm()"
                   [ngClass]="{'borderRed':defaultPassword.isEmptyNewPassword || defaultPassword.isPasswordFormatInValid }"
                   formControlName="newPassword" />
            <span title="{{defaultPassword.passwordFormatMatch}}" *ngIf="defaultPassword.isPasswordFormatInValid " kendoTooltip
                  class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
          </div>
        </div>
        <div class="form-group col-md-12">
          <label class="lblCls">
            {{defaultPassword.confirmPasswordLbl}}<span class="requiredField">*</span>
          </label>
          <input type="password" kendoTextBox class="kendoInput" name="confirmPassword"
                 [ngClass]="{'borderRed':defaultPassword.isEmptyConfirmPassword && defaultPassword.isSubmitted}"
                 (blur)="validateDefaultPasswordForm()" formControlName="confirmPassword" />
          <span title="{{defaultPassword.confirmPasswordMatch}}" *ngIf="defaultPassword.isPasswordNotMatched && defaultPassword.isSubmitted" kendoTooltip
                class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
        </div>
      </div>

      <div class="dialog-btn-section">
        <div class="row">
          <div class="col-sm-12 float-left">
            <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 btn-align-center">
            <div class="btn-group" role="group">
              <button (click)="closeDefaultPasswordDialog()" class=" m-3 btn k-button dialogBtnSize" kendoButton [disabled]="passwordSaveInProcess">
                Close
              </button> &nbsp;&nbsp;
              <button (click)="changeDefaultPassword()" class="m-3 btn btn-success dialogBtnSize" kendoButton
                      [disabled]="passwordSaveInProcess">
                Save<kendo-loader *ngIf="passwordSaveInProcess" style="color:blue"></kendo-loader>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </kendo-dialog>
</section>
<div class="passwordChange-wrapper">
  <kendo-dialog *ngIf="openedPassword" (close)="close('cancel')" [minWidth]="250" [width]="450">
    <p style="margin: 30px; text-align: center; font-size:20px;">
      <strong>Thank you,&nbsp;</strong> {{userId}}!<br />
      Your password has been updated.
    </p>

    <!--<button kendoButton (click)="close('yes')" primary="true">Yes</button>-->
    <div class=text-center>
      <button kendoButton primary="true" (click)="closePassword()" class="">
        Ok
      </button>
    </div>
  </kendo-dialog>
</div>
<!--end passwordChange-wrapper-->
<!--modal dialog for user terms and condition agreement-->
<section class="dialogSection">
  <kendo-dialog title="Terms & Conditions" *ngIf="termsConditionAgreement.opened" (close)="closeTermsConditionDialog()">
    <div class="col-sm-12">
      <div class="termsAndConditions">
        Terms and Conditions description
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 btn-align-center">
        <div class="btn-group" role="group">
          <button (click)="termsConditionSubmit('disagree')" class=" m-3 btn k-button dialogBtnSize" kendoButton [disabled]="inProgress">
            I Disagree
          </button> &nbsp;&nbsp;
          <button (click)="termsConditionSubmit('agree')" class="m-3 btn btn-success dialogBtnSize" kendoButton
                  [disabled]="inProgress">
            I Agree<kendo-loader *ngIf="inProgress" style="color:blue"></kendo-loader>
          </button>
        </div>
      </div>
    </div>
  </kendo-dialog>
</section>
